import React, { useMemo, useEffect, useState, useCallback } from "react";
import { useTable, useFilters, usePagination } from "react-table";

import axiosInstance from "services/AxiosInstance";
import { getDefaultParams } from "services/DefaultParamets";
import Tables from "jsx/components/CitoPlus/components/tables";
import SearchInput from "jsx/components/CitoPlus/components/input_search";
import { LinkPrimary } from "jsx/components/CitoPlus/components/CitoPlusLink";
import { handleErrors } from "jsx/components/CitoPlus/components/ErrorHandlingComponent";
import PreRegistroVisitantesModal from "./PreRegistroVisitantesModal";

import "../../../table/FilteringTable/filtering.css";

export const PreRegistroVisitantes = () => {
  const URL = "/api/v3/visitantes/pre-registro/admin/";

  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");

  const [nextUrl, setNextUrl] = useState([]);
  const [previousUrl, setPreviousUrl] = useState([]);

  const [defaultParams] = useState(getDefaultParams);

  const [showModal, setShowModal] = useState(false);
  const [selectedSlug, setSelectedSlug] = useState(null);

  // TABLA
  const columns = useMemo(
    () => [
      {
        id: "created_at",
        Header: "Fecha Creación",
        accessor: "created_at",
        disableFilters: true,
        disableSortable: false,
      },
      {
        id: "nombres",
        Header: "Nombres",
        accessor: "nombres",
        disableFilters: true,
      },
      {
        id: "fecha_inicio",
        Header: "Fecha Inicio",
        accessor: "fecha_inicio",
        disableFilters: true,
        disableSortable: false,
      },

      {
        id: "fecha_final",
        Header: "Fecha Final",
        accessor: "fecha_final",
        disableFilters: true,
        disableSortable: false,
      },

      {
        id: "autorizado_por",
        Header: "Autorizado Por",
        accessor: "autorizado_por",
        disableFilters: true,
      },

      {
        id: "correo",
        Header: "Correo",
        accessor: "correo",
        disableFilters: true,
      },
      {
        id: "inmueble",
        Header: "Inmueble",
        accessor: "inmueble",
        disableFilters: true,
      },
      {
        id: "actions",
        Header: "Acciones",
        disableFilters: true,
        disableSortable: true,
        accessor: (row) => {
          return (
            <React.Fragment>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => handleOpenModal(row.slug)}
              >
                <i className="fas fa-eye"></i>
              </button>
            </React.Fragment>
          );
        },
      },
    ],
    [],
  );

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const debouncedfetchUrl = useCallback(
    debounce((pageIndex, search) => {
      fetchUrl(pageIndex, search);
    }, 500),
    [],
  );

  useEffect(() => {
    fetchUrl(1);
  }, []);

  const fetchUrl = async (pageIndex = 1, search = "", ordering = []) => {
    defaultParams.page = pageIndex;

    if (searchValue !== "") {
      defaultParams.search = searchValue;
      search = searchValue;
    } else {
      defaultParams.search = search;
    }

    setLoading(true);
    try {
      if (pageIndex < 1 || pageIndex > totalPages) {
        return;
      }
      const response = await axiosInstance.get(URL, {
        params: {
          ...defaultParams,
          page: pageIndex,
          search: search,
          ordering: ordering,
        },
      });
      setNextUrl(response.data.next);
      setPreviousUrl(response.data.previous);
      setTotalPages(response.data.total_pages);
      setCurrentPage(response.data.current_page);
      setData(response.data.results);
    } catch (error) {
      handleErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    setSearchValue(value);
    setLoading(true);
    debouncedfetchUrl(1, value);
  };

  const handleEnterPress = () => {
    // Lógica para manejar la tecla Enter, si es necesario
  };

  const handleClearClick = () => {
    handleSearchChange("");
  };

  const handleSortingChange = (column) => {
    const { id } = column;

    const newOrder =
      sortField === id ? (order === "asc" ? "desc" : "asc") : "asc";

    setSortField(id);
    setOrder(newOrder);
    setLoading(true);
    fetchUrl(1, searchValue, `${newOrder === "desc" ? "-" : ""}${id}`);
  };

  const handleOpenModal = (slug) => {
    setSelectedSlug(slug);
    setShowModal(true);
  };

  const tableInstance = useTable(
    {
      columns,
      data,
      manualPagination: true,
      pageCount: totalPages,
    },
    useFilters,
    usePagination,
  );

  const { page } = tableInstance;

  return (
    <>
      <div className="d-flex aling-items-center mb-4 flex-wrap">
        <h4 className="fs-20 font-w600 me-auto">Pre Registro Visitantes</h4>
      </div>
      <div className="card">
        <div className="card-header">
          <div className="card-tools">
            <SearchInput
              value={searchValue}
              onSearchChange={handleSearchChange}
              onEnterPress={handleEnterPress}
              onClearClick={handleClearClick}
            />
          </div>
        </div>
        <div className="card-body">
          {loading ? (
            <p>Cargando...</p>
          ) : data.length === 0 ? (
            <p>No hay datos disponibles.</p>
          ) : (
            <Tables
              columns={columns}
              data={data}
              loading={loading}
              totalPages={totalPages}
              currentPage={currentPage}
              fetchUrl={fetchUrl}
              handleSortingChange={handleSortingChange}
              nextUrl={nextUrl}
              previousUrl={previousUrl}
              sortField={sortField}
              order={order}
              page={page}
            />
          )}
        </div>
      </div>

      <PreRegistroVisitantesModal
        show={showModal}
        onHide={() => setShowModal(false)}
        slug={selectedSlug}
      />
    </>
  );
};

export default PreRegistroVisitantes;
